import { render, staticRenderFns } from "./401.vue?vue&type=template&id=6c4003d4&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"
import style0 from "./401.vue?vue&type=style&index=0&id=6c4003d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4003d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4003d4')) {
      api.createRecord('6c4003d4', component.options)
    } else {
      api.reload('6c4003d4', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=6c4003d4&scoped=true", function () {
      api.rerender('6c4003d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/error-page/401.vue"
export default component.exports